export const COMPANY_INFO = {
  name: "NF-Polering",
  cvr: "35 01 70 89",
  phone: "30 14 60 70",
  phoneRaw: "30146070",
  phoneTel: "tel:30146070",
  email: "kontakt@nf-polering.dk",
  contactEmail: "kontakt@nf-polering.dk",
  address: "Bøstrupvej 23, 4200 Slagelse",
  logoUrl: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/logo.svg",
  logoPng: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/logo.png",
  openingHours: "Mandag – Fredag: 08:00 – 16:00 | Lørdag – Søndag: 10:00 – 14:00 (På telefon)",
  openingHoursWeekdays: "Mandag – Fredag: 08:00 – 16:00",
  openingHoursWeekend: "Lørdag – Søndag: 10:00 – 14:00 (På telefon)",
  areas: [
    "Slagelse",
    "Slots Bjergby",
    "Sorø",
    "Skælskør",
    "Korsør",
    "Dalmose",
    "Næstved",
    "Karrebæksminde",
    "Ringsted",
    "Høng",
    "Fuglebjerg",
    "Vemmelev",
    "Stillinge"
  ]
};

export const NAVIGATION_LINKS = [
  {
    label: "Forside",
    href: "/"
  },
  {
    label: "Vinduespudsning",
    href: "/vinduespudsning"
  },
  {
    label: "Solcellevask",
    href: "/solcellevask"
  },
  {
    label: "Fliserens",
    href: "/fliserens"
  },
  {
    label: "Dækningsområder",
    href: "/daekningsomraader"
  },
  {
    label: "Om os",
    href: "/om-os"
  },
  {
    label: "Kontakt",
    href: "/kontakt"
  }
];

export const TESTIMONIALS = [
  {
    quote: "Ruderne blev fuldstændig som nye. Hurtigt, grundigt og efterlod alt pænt. Kan varmt anbefales!",
    author: "Mette",
    location: "Sorø",
    stars: 5
  },
  {
    quote: "Simpelt, ærligt og lige til. Fik en skarp pris med det samme og altid et flot resultat.",
    author: "Louise",
    location: "Korsør",
    stars: 5
  },
  {
    quote: "Kommer altid til tiden og leverer et fejlfrit stykke arbejde. Klart en anbefaling herfra!",
    author: "Thomas",
    location: "Slagelse",
    stars: 5
  }
];

export const BENEFITS = [
  {
    icon: "fa-location-dot",
    title: "Lokalt på Vestsjælland",
    desc: "Vi kender området og er hurtigt fremme"
  },
  {
    icon: "fa-bolt",
    title: "Hurtig tid",
    desc: "Fleksible aftaler der passer til dig"
  },
  {
    icon: "fa-tag",
    title: "Skarpe priser",
    desc: "Gennemsigtig prisfastsættelse uden skjulte gebyrer"
  },
  {
    icon: "fa-circle-check",
    title: "Professionelt resultat",
    desc: "Kvalitet og grundighed – hver gang"
  }
];

export const VINDUER_PRICES = [
  {
    title: "Udvendig",
    subtitle: "Vinduespolering",
    price: "99,-",
    unit: "Fra.",
    popular: false,
    features: [
      "Et-plans hus",
      "Professionel vinduespolering",
      "Grundig og professionel service",
      "Fast aftale eller enkeltbesøg",
      "Op til 15 Ruder"
    ],
    note: "Perfekt til dig, der ønsker flotte og rene vinduer uden besvær."
  },
  {
    title: "Udvendig & Indvendig",
    subtitle: "Vinduespolering",
    price: "149,-",
    unit: "Fra.",
    popular: true,
    features: [
      "Et-plans hus",
      "Vinduer pudset på begge sider",
      "Grundig og professionel service",
      "Fast aftale eller enkeltbesøg",
      "Op til 15 Ruder"
    ],
    note: "Vores mest populære løsning til boligejere, der ønsker det bedste resultat."
  },
  {
    title: "Indvendig",
    subtitle: "Vinduespolering",
    price: "99,-",
    unit: "Fra.",
    popular: false,
    features: [
      "Et-plans hus",
      "Pudsning af alle indvendige vinduer",
      "Grundig og professionel service",
      "Fast aftale eller enkeltbesøg",
      "Op til 15 Ruder"
    ],
    note: "Ideelt til dig, der ønsker helt rene vinduer indendørs."
  }
];

export const VINDUER_DISCOUNTS = [
  {
    frequency: "4 uger",
    discount: "10% rabat",
    tag: "Mest populær",
    badge: "Mest populær"
  },
  {
    frequency: "8 uger",
    discount: "5% rabat",
    tag: "God balance",
    badge: null
  },
  {
    frequency: "12 uger",
    discount: "Normalpris",
    tag: "Fleksibel løsning",
    badge: null
  }
];

export const FLISERENS_PACKAGES = [
  {
    id: "basis",
    name: "Basis",
    subtitle: "Fliserens",
    pricePerM2: 24,
    features: [
      "En effektiv opfriskning af dine fliser",
      "Professionel fliserens",
      "Grundig skylning efter rens",
      "Fjerner snavs og belægninger",
      "Tilkøb algebehandling"
    ],
    description: "God til dig, der primært ønsker rene og flotte fliser igen.",
    popular: false
  },
  {
    id: "premium",
    name: "Premium",
    subtitle: "Fliserens",
    pricePerM2: 29,
    features: [
      "Professionel fliserens",
      "Grundig skylning",
      "Algebehandling",
      "Imprægnering af fliserne",
      "Beskyttende efterbehandling"
    ],
    description: "En komplet behandling, hvor fliserne både bliver renset og efterbehandlet.",
    popular: true
  },
  {
    id: "eksklusiv",
    name: "Eksklusiv",
    subtitle: "Fliserens",
    pricePerM2: 36,
    features: [
      "Professionel fliserens",
      "Grundig skylning",
      "Algebehandling",
      "Imprægnering",
      "Nyt fugesand"
    ],
    description: "Den ultimative løsning, hvor fliserne renses, beskyttes og får nyt fugesand.",
    popular: false
  }
];

export const CITY_PAGES = {
  slagelse: {
    slug: "vinduespudser-slagelse",
    cityName: "Slagelse",
    title: "Vinduespudser Slagelse | Professionel Vinduespolering",
    metaDescription: "Få skinnende rene vinduer med lokal vinduespudser i Slagelse. Konkurrencedygtige priser, faste aftaler og høj kvalitet. Kontakt os i dag.",
    h1: "Vinduespudser i Slagelse",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/img-1811_f7b7c065.jpg",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/file.png",
    localAreas: "Slagelse by, Slots Bjergby, Hejninge, Kirke Stillinge, Svenstrup, Havrebjerg og omegn.",
    textSections: [
      {
        h2: "Vinduespudser i Slagelse – Professionel vinduespolering til private og erhverv",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/file.png",
        imageAlt: "Professionel vinduespudser ved Slagelse byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en pålidelig og kvalitetsbevidst vinduespudser i Slagelse? Hos NF-Polering tilbyder vi professionel vinduespolering til både private boliger, erhverv, butikker og boligforeninger i Slagelse og omegn. Vi sikrer rene ruder, god service og et flot resultat hver eneste gang.",
          "Vi ved, hvor stor en forskel rene vinduer gør for et hjem eller en virksomhed. Stribefri ruder lukker mere naturligt dagslys ind og giver hele ejendommen et frisk og præsentabelt udtryk. Derfor lægger vi stor vægt på grundighed og detaljer, uanset om vi pudser vinduer på et parcelhus, i en lejlighed eller i en større erhvervsbygning."
        ]
      },
      {
        h2: "Kvalitetsbevidst vinduespolering i Slagelse og omegn",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/img-1811.jpg",
        imageAlt: "Kvalitetsbevidst vinduespolering i Slagelse og omegn – NF Polering",
        paragraphs: [
          "Med professionelt udstyr og mange års erfaring inden for faget udfører vi vinduespolering effektivt og sikkert. Vi anvender moderne teknikker, herunder rentvandsanlæg og teleskopstænger, som gør det muligt at vaske vinduer i højden uden brug af tunge lifte.",
          "Hos NF-Polering går vi ikke på kompromis med kvaliteten. Vi arbejder grundigt og effektivt og sørger for, at dine vinduer efterlades skinnende rene. Vores mål er ikke blot at pudse vinduer – vi ønsker at skabe tilfredse kunder, der kan nyde udsigten gennem rene ruder hver dag."
        ]
      },
      {
        h2: "Vinduespolering til private i Slagelse",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/fullsizerender.jpeg",
        imageAlt: "Professionel vinduespolering af boliger og ejendomme i Slagelse – NF Polering",
        paragraphs: [
          "Mange boligejere oplever, at det kan være både tidskrævende og besværligt at pudse vinduer selv. Især større boliger eller huse med mange vinduer kan kræve flere timers arbejde, og resultatet bliver ikke altid som ønsket.",
          "Med professionel vinduespolering fra NF-Polering slipper du for besværet. Vi sørger for, at dine vinduer bliver rengjort professionelt og effektivt, så du kan bruge din tid på noget andet."
        ],
        bulletList: [
          "Villaer",
          "Parcelhuse",
          "Rækkehuse",
          "Lejligheder",
          "Sommerhuse",
          "Ejerforeninger",
          "Andelsboliger"
        ],
        closingText: "Uanset boligens størrelse kan vi tilbyde en løsning, der matcher dine ønsker."
      }
    ]
  },
  slotsbjergby: {
    slug: "vinduespudser-slots-bjergby",
    cityName: "Slots Bjergby",
    title: "Vinduespudser Slots Bjergby | Professionel Vinduespolering | NF-Polering",
    metaDescription: "Lokal vinduespudser i Slots Bjergby og omegn. Få stribefri rene ruder til faste lave priser, hurtig responstid og fleksible abonnementsaftaler.",
    h1: "Vinduespudser i Slots Bjergby",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-vinduespudsning-oversigt.png",
    byskiltImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/nf-1-5.jpg",
    localAreas: "Slots Bjergby, Hashøj, Slagelse Syd, Gerlev og nærliggende lokalområder.",
    textSections: [
      {
        h2: "Vinduespudser i Slots Bjergby – Professionel vinduespolering til private og erhverv",
        image: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/nf-1-5.jpg",
        imageAlt: "Professionel vinduespudser ved Slots Bjergby byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en pålidelig og lokal vinduespudser i Slots Bjergby? Hos NF-Polering pudser vi regelmæssigt vinduer for boligejere og mindre erhverv i Slots Bjergby og det omkringliggende lokalområde. Vi sikrer altid krystalklare, stribefri ruder til konkurrencedygtige priser.",
          "Slots Bjergby ligger lige i vores nærområde, hvilket betyder hurtig fleksibilitet, faste ruter og lokal service af højeste standard. Uanset om du bor i parcelhus, villa eller rækkehus, klarer vi både udvendig og indvendig vinduespolering med et smil."
        ]
      },
      {
        h2: "Kvalitetsbevidst vinduespolering i Slots Bjergby",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/img-1811.jpg",
        imageAlt: "Kvalitetsbevidst vinduespolering i Slots Bjergby og omegn – NF Polering",
        paragraphs: [
          "Vi anvender professionelt udstyr, herunder moderne ultra-rent osmosevand og letvægts teleskopstænger. Det giver skinnende rene ruder uden kalkstriber eller kemikalierester – også ved svært tilgængelige vinduer i højden.",
          "Vi overholder altid vores aftaler og sørger for, at dit hjem efterlades pænt og ordentligt. Med en fast abonnementsordning slipper du for besværet og kan altid nyde udsigten gennem rene ruder."
        ]
      },
      {
        h2: "Vinduespolering til private i Slots Bjergby",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/fullsizerender.jpeg",
        imageAlt: "Professionel vinduespolering af boliger i Slots Bjergby – NF Polering",
        paragraphs: [
          "Mange husejere i Slots Bjergby vælger en fast aftale hver 4., 8. eller 12. uge. Det sparer dig for besværet, og du slipper for at skulle balancere på stiger eller bruge weekender på vinduespudsning.",
          "Vi leverer altid 100% tilfredshedsgaranti på vores arbejde, og finder du mod forventning en stribe, udbedrer vi det med det samme."
        ],
        bulletList: [
          "Villaer & parcelhuse",
          "Rækkehuse & gårdhaver",
          "Udestuer & glastage",
          "Indvendig & udvendig polering",
          "Fleksible abonnementsintervaller",
          "Ingen binding på aftaler"
        ],
        closingText: "Kontakt os i dag og få en fast, god pris på vinduespolering i Slots Bjergby."
      }
    ]
  },
  soroe: {
    slug: "vinduespudser-soroe",
    cityName: "Sorø",
    title: "Vinduespudser i Sorø | Vinduespolering af høj kvalitet",
    metaDescription: "Vinduespolering i Sorø til konkurrencedygtige priser. Kontakt NF-Polering i dag.",
    h1: "Vinduespudser i Sorø",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-soroe-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/sora.png",
    localAreas: "Sorø by, Dianalund, Stenlille, Fjenneslev, Pedersborg, Ruds Vedby og de omkringliggende områder.",
    textSections: [
      {
        h2: "Vinduespudser i Sorø – Professionel vinduespolering til private og erhverv",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/sora.png",
        imageAlt: "Professionel vinduespudser ved Sorø byskilt – NF Polering",
        paragraphs: [
          "Når du søger en professionel vinduespudser i Sorø, er det vigtigt at vælge en virksomhed, der leverer høj kvalitet, god service og flotte resultater hver gang. Hos NF-Polering tilbyder vi professionel vinduespolering til både private boliger og virksomheder i Sorø og omegn. Vi hjælper kunder med at holde deres vinduer rene året rundt, så boligen eller virksomheden altid fremstår præsentabel og indbydende.",
          "Rene vinduer gør en større forskel, end mange tror. De giver mere naturligt lys, forbedrer udsynet og bidrager til et pænere helhedsindtryk af ejendommen. I et område som Sorø, hvor naturen er tæt på, oplever mange boligejere, at pollen, støv og alger hurtigt sætter sig på ruderne. Med regelmæssig vinduespolering sikrer du, at dine vinduer altid fremstår rene og velholdte.",
          "NF-Polering udfører vinduespolering i hele Sorø Kommune, herunder Sorø by, Dianalund, Stenlille, Fjenneslev, Pedersborg, Ruds Vedby og de omkringliggende områder. Uanset om du bor i villa, rækkehus, lejlighed eller sommerhus, kan vi tilbyde en løsning, der passer til netop dine behov."
        ]
      },
      {
        h2: "Lokal vinduespudser med fokus på kvalitet",
        paragraphs: [
          "Som lokal vinduespudser i Sorø lægger vi stor vægt på pålidelighed og kundetilfredshed. Vi ønsker at være det naturlige valg for boligejere og virksomheder, der ønsker en professionel samarbejdspartner til deres vinduespolering. Derfor arbejder vi målrettet på at levere en service, hvor kvalitet og kundeservice går hånd i hånd.",
          "Sorø er et område med mange forskellige boligtyper, virksomheder og ejendomme, og vi har erfaring med alt fra mindre parcelhuse til større erhvervsbygninger. Uanset opgavens størrelse møder vi op med samme fokus på kvalitet og detaljerne i arbejdet. Vores kunder vælger os, fordi de ønsker flotte vinduer, pålidelig service og en samarbejdspartner, der holder sine aftaler.",
          "Hvis du leder efter en erfaren vinduespudser i Sorø, som sætter kvalitet og kundetilfredshed i centrum, er NF-Polering klar til at hjælpe. Vi arbejder hver dag for at levere skinnende rene vinduer og skabe langvarige kunderelationer gennem godt håndværk og professionel service."
        ]
      },
      {
        h2: "Vinduespolering til private i Sorø",
        paragraphs: [
          "Hos NF-Polering tilbyder vi vinduespolering til både private og erhverv i Sorø. Vi ved, at hver ejendom er forskellig, og derfor tilpasser vi vores løsninger efter kundens ønsker og behov. Vores mål er altid at levere et flot og ensartet resultat, som skaber værdi for kunden.",
          "For private boligejere betyder rene vinduer mere dagslys i hjemmet og et pænere udtryk både inde og ude. Mange vælger en fast aftale, så vinduerne altid fremstår flotte uden selv at skulle bruge tid på rengøringen. For virksomheder handler rene vinduer om at skabe et professionelt førstehåndsindtryk over for kunder, gæster og medarbejdere.",
          "Vi anvender professionelle metoder og moderne udstyr, som gør det muligt at udføre vinduespolering effektivt og sikkert. Det betyder, at vi kan håndtere både mindre boliger og større ejendomme, samtidig med at vi opretholder den høje kvalitet, som vores kunder forventer. Vores fokus er altid på grundighed, service og et resultat, der lever op til forventningerne."
        ]
      }
    ]
  },
  skaelskoer: {
    slug: "vinduespudser-skaelskoer",
    cityName: "Skælskør",
    title: "Vinduespudser Skælskør | Professionel Vinduespolering | NF-Polering",
    metaDescription: "Lokal vinduespudser i Skælskør. Professionel vinduespolering til private og erhverv. Faste lave priser, flotte resultater og fleksible aftaler.",
    h1: "Vinduespudser i Skælskør",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-skaelskoer-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/ska-lska-r.png",
    textSections: [
      {
        h2: "Professionel Vinduespudser i Skælskør",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/ska-lska-r.png",
        imageAlt: "Professionel vinduespudser ved Skælskør byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en pålidelig vinduespudser i Skælskør? Hos NF-Polering tilbyder vi professionel vinduespolering til både private boligejere, virksomheder, butikker og boligforeninger i hele Skælskør og omegn.",
          "Vi ved, hvor stor forskel rene vinduer gør for både boligens udseende og mængden af naturligt lys i hjemmet.",
          "Vi arbejder med fokus på kvalitet, service og flotte resultater hver eneste gang. Uanset om du ønsker en fast aftale eller blot en enkelt pudsning, sørger vi for skinnende rene vinduer uden striber. Med moderne udstyr og stor erfaring kan vi også klare vinduer i højden, så du slipper for besværet og risikoen ved selv at skulle op på stiger."
        ]
      },
      {
        h2: "Vinduespolering til Private og Erhverv i Skælskør",
        paragraphs: [
          "NF-Polering hjælper både private kunder og erhvervskunder i Skælskør med professionel vinduespolering. Vi tilbyder fleksible løsninger, der passer til dine behov, uanset om du bor i villa, rækkehus eller lejlighed, eller driver virksomhed med behov for regelmæssig vinduespudsning.",
          "Rene vinduer giver et godt førstehåndsindtryk og bidrager samtidig til et lysere og mere indbydende miljø. Derfor vælger mange kunder i Skælskør en fast aftale, hvor vi kommer med faste intervaller og sørger for, at vinduerne altid fremstår flotte og velholdte.",
          "Vi lægger vægt på punktlighed, grundighed og en personlig service, så du altid kan føle dig tryg ved at vælge NF-Polering som din lokale vinduespudser."
        ]
      },
      {
        h2: "Lokal Vinduespudser i Skælskør med Fokus på Kvalitet",
        paragraphs: [
          "Som lokal vinduespudser i Skælskør er vi stolte af at levere høj kvalitet til konkurrencedygtige priser. Vi ved, at tilfredse kunder er grundlaget for en sund virksomhed, og derfor går vi aldrig på kompromis med resultatet.",
          "Hver opgave udføres med stor omhu, så dine vinduer efterlades rene og klare.",
          "Vi dækker hele Skælskør og de omkringliggende områder og hjælper både nye og eksisterende kunder med alt fra almindelig vinduespolering til større erhvervsopgaver. Ønsker du et uforpligtende tilbud på vinduespolering i Skælskør, er du altid velkommen til at kontakte NF-Polering. Vi står klar til at hjælpe dig med rene vinduer og en professionel løsning, der passer til dine behov."
        ]
      }
    ]
  },
  dalmose: {
    slug: "vinduespudser-dalmose",
    cityName: "Dalmose",
    title: "Vinduespudser Dalmose | Professionel Vinduespolering",
    metaDescription: "Professionel vinduespudser i Dalmose til private og erhverv. Få skinnende rene vinduer, faste aftaler og konkurrencedygtige priser hos NF-Polering.",
    h1: "Vinduespudser i Dalmose",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-dalmose-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/dalmose.png",
    textSections: [
      {
        h2: "Vinduespudser i Dalmose – Klare ruder året rundt",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/dalmose.png",
        imageAlt: "Professionel vinduespudser ved Dalmose byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en professionel vinduespudser i Dalmose? Hos NF-Polering tilbyder vi kvalitetsbevidst vinduespolering til både private boliger, virksomheder og boligforeninger i Dalmose og omegn. Vi ved, hvor stor forskel rene vinduer gør for både hjemmets udseende og mængden af naturligt lys i hverdagen.",
          "Når du vælger NF-Polering som din lokale vinduespudser i Dalmose, får du en pålidelig samarbejdspartner med fokus på kvalitet, service og flotte resultater. Vi tilbyder både faste abonnementsaftaler og enkeltstående pudsninger, så du altid kan vælge den løsning, der passer bedst til dine behov."
        ]
      },
      {
        h2: "Lokal vinduespolering i Dalmose til private og erhverv",
        paragraphs: [
          "Vi hjælper dagligt kunder i Dalmose med professionel vinduespolering. Uanset om du bor i villa, rækkehus eller lejlighed, sørger vi for, at dine ruder fremstår skinnende rene. Vi servicerer også erhvervskunder, hvor rene vinduer er med til at skabe et professionelt førstehåndsindtryk for kunder og besøgende.",
          "Hos NF-Polering arbejder vi effektivt og grundigt, og vi går aldrig på kompromis med kvaliteten. Vi anvender professionelt udstyr, som sikrer et flot resultat hver gang. Vores kunder vælger os ofte på grund af vores stabile service, fleksible løsninger og fokus på kundetilfredshed."
        ]
      },
      {
        h2: "NF-Polering – Din lokale vinduespudser i Dalmose",
        paragraphs: [
          "Som lokal vinduespudser i Dalmose lægger vi stor vægt på personlig service og langvarige kunderelationer. Vi tilbyder fleksible intervaller på 4, 8 eller 12 uger, så dine vinduer altid fremstår rene og præsentable året rundt.",
          "Uanset om du har få eller mange vinduer, kan vi hjælpe. Vi kommer til tiden, leverer et flot resultat og sørger for, at du får mest muligt ud af dine vinduer.",
          "Kontakt NF-Polering i dag og få et uforpligtende tilbud på professionel vinduespolering i Dalmose. Vi står klar til at hjælpe både private og erhverv med rene vinduer og høj service."
        ]
      }
    ]
  },
  naestved: {
    slug: "vinduespudser-naestved",
    cityName: "Næstved",
    title: "Vinduespudser Næstved | Professionel Vinduespolering",
    metaDescription: "Søger du en vinduespudser i Næstved? Vi tilbyder vinduespolering med fokus på kvalitet, service og flotte resultater.",
    h1: "Vinduespudser i Næstved",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-naestved-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/byskilt-na-stved.png",
    textSections: [
      {
        h2: "Vinduespudser Næstved – Klare Ruder til Private og Erhverv",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/byskilt-na-stved.png",
        imageAlt: "Professionel vinduespudser ved Næstved byskilt – NF Polering",
        paragraphs: [
          "Hos NF-Polering tilbyder vi professionel vinduespudsning i Næstved og omegn til både private boligejere, virksomheder, butikker og boligforeninger. Rene vinduer giver ikke blot et flottere udtryk, men sørger også for mere dagslys i hjemmet eller på arbejdspladsen. Vi arbejder med fokus på kvalitet, service og grundighed, så du altid kan være sikker på et flot resultat.",
          "Vi tilbyder både faste abonnementsordninger og enkeltstående pudsninger, alt efter hvad der passer bedst til dine behov. Med moderne udstyr og rentvandsanlæg kan vi pudse vinduer effektivt og sikkert – også på højere bygninger. Uanset om du bor i centrum af Næstved eller i de omkringliggende områder, står vi klar til at hjælpe med skinnende rene ruder året rundt."
        ]
      },
      {
        h2: "Professionel Vinduespolering i Næstved med Fokus på Kvalitet",
        paragraphs: [
          "Når du vælger NF-Polering som din vinduespudser i Næstved, vælger du en lokal samarbejdspartner med fokus på høj kvalitet og god kundeservice.",
          "Vi ved, hvor stor forskel rene vinduer gør for både boliger og erhvervsejendomme, og derfor går vi aldrig på kompromis med resultatet.",
          "Vi pudser alt fra mindre parcelhuse til større villaer, kontorer og erhvervsbygninger.",
          "Ved hjælp af teleskopstænger og rentvandssystemer kan vi nå vinduer i højden uden brug af stiger, hvilket både giver et bedre arbejdsmiljø og en mere sikker løsning. Mange af vores kunder i Næstved vælger faste aftaler, så deres vinduer altid fremstår rene og præsentable gennem hele året."
        ]
      },
      {
        h2: "Lokal Vinduespudser i Næstved – Få et Uforpligtende Tilbud",
        paragraphs: [
          "Leder du efter en pålidelig vinduespudser i Næstved, NF-Polering er klar til at hjælpe.",
          "Vi tilbyder konkurrencedygtige priser, fleksible løsninger og professionel service, uanset om du ønsker vinduespudsning hver måned eller blot har brug for hjælp et par gange om året.",
          "Vi dækker hele Næstved og de omkringliggende områder og hjælper både private og erhverv med at holde vinduerne flotte og rene. Kontakt os allerede i dag for et uforpligtende tilbud på vinduespolering i Næstved.",
          "Vi finder en løsning, der passer til netop dine behov, så du kan nyde udsigten gennem skinnende rene vinduer."
        ]
      }
    ]
  },
  karrebaeksminde: {
    slug: "vindusepudser-karrebaeksminde",
    cityName: "Karrebæksminde",
    title: "Vinduespudser Karrebæksminde | Professionel Vinduespudsning",
    metaDescription: "Få skinnende rene vinduer i Karrebæksminde. NF Polering tilbyder professionel vinduespudsning til private og erhverv med faste abonnementer og konkurrencedygtige priser.",
    h1: "Din lokale og professionelle vinduespudser Karrebæksminde",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-karrebaeksminde-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/vestsja-lland.png",
    textSections: [
      {
        h2: "Din lokale og professionelle vinduespudser Karrebæksminde",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/vestsja-lland.png",
        imageAlt: "Professionel vinduespudser på Vestsjælland og Karrebæksminde – NF Polering",
        paragraphs: [
          "Saltvand og flyvesand fra kysten sætter sig hurtigt fast på ruderne i 4736 Karrebæksminde. Som din faste vinduespudser Karrebæksminde fjerner NF Polering det genstridige snavs og efterlader dine vinduer skinnende rene.",
          "Vi tilbyder udvendig og indvendig polering til både private boliger, sommerhuse og erhvervsdrivende i lokalområdet. Vores faste priser starter fra 189 kroner for et almindeligt etplanshus, og vi garanterer et pletfrit resultat hver gang.",
          "Kystklimaet stiller særlige krav til vedligeholdelsen af dine vinduer. Vinden fra yderhavnen bærer mikroskopiske saltpartikler med sig, som langsomt nedbryder træværk og gør ruderne matte. Regelmæssig vinduesvask beskytter dine vinduesrammer og sikrer et optimalt lysindfald i din bolig.",
          "Vi kender området omkring Karrebæksminde bro indgående og tilpasser vores metoder til de lokale vejrforhold."
        ]
      },
      {
        h2: "Hvorfor vælge NF Polering som din vinduespudser Karrebæksminde?",
        paragraphs: [
          "Gennemsigtighed og pålidelighed er fundamentet i vores forretning. Du får altid en fast pris på din opgave, inden vi går i gang. Vi benytter moderne udstyr og miljøvenlige produkter, som skåner både dine vinduer og den lokale natur. Vores team overholder altid de aftalte tider, så du trygt kan planlægge din dag.",
          "Vi tilbyder en række konkrete fordele for vores kunder i Karrebæksminde og omegn. Vores prissætning er simpel og uden skjulte gebyrer. For et typisk etplanshus med op til 15 vinduer koster en udvendig polering 189 kroner. Ønsker du både indvendig og udvendig pudsning af samme antal vinduer, er prisen 345 kroner. Har du udelukkende brug for indvendig pudsning, koster det 225 kroner. Disse startpriser gør det nemt for dig at vurdere omkostningerne på forhånd.",
          "Kvaliteten af vores arbejde er bakket op af en solid reklamationsret. Skulle du mod forventning finde fejl eller mangler ved vores polering, har du et vindue på 24 til 48 timer til at kontakte os. Vi rykker hurtigt ud og retter fejlen uden ekstra beregning. Du kan læse de fulde detaljer om vores vilkår i vores handelsbetingelser."
        ]
      },
      {
        h2: "Skånsom vinduesvask med rentvandsanlæg og teleskopstænger",
        paragraphs: [
          "Mange ældre huse og sommerhuse i Karrebæksminde har vinduer placeret i højden eller på svært tilgængelige steder. Vi løser disse opgaver sikkert fra jorden ved hjælp af moderne rentvandsanlæg og teleskopstænger. Denne metode fjerner behovet for stiger, hvilket minimerer risikoen for skader på dine blomsterbede, facader og vinduesrammer.",
          "Et rentvandsanlæg filtrerer almindeligt postevand for kalk, jern og andre mineraler. Resultatet er 100 procent rent vand. Når vi vasker dine vinduer med dette vand, fordamper det uden at efterlade striber eller kalkpletter. Metoden er yderst effektiv mod det genstridige salt og sand, som præger kystnære boliger. Samtidig er det en miljøvenlig løsning, da vi ofte kan rengøre ruderne helt uden brug af sæbe.",
          "Når vi udfører traditionel manuel polering, anvender vi skånsomme produkter. Flere af vores konkurrenter fremhæver brugen af Svanemærket sæbe, og vi deler denne tilgang til miljøansvar. Vi bruger professionelle sæber, der opløser snavs effektivt uden at belaste havmiljøet omkring Karrebæksminde."
        ]
      },
      {
        h2: "Indvendig polering med respekt for dit hjem",
        paragraphs: [
          "Udvendig polering fjerner salt og snavs fra vejret, men indvendig pudsning er lige så vigtig for et perfekt resultat. Stegeos, støv og aftryk fra kæledyr eller børn danner hurtigt en hinde på indersiden af glasset. Vi tilbyder grundig indvendig polering som en naturlig del af vores professionel vinduespudsning.",
          "Når vi arbejder inde i dit hjem, gør vi det med stor forsigtighed. Vi tager skoene af eller benytter overtrækssko. Vi dækker gulvet af under vinduerne for at gribe eventuelle vanddråber, og vi tørrer altid vindueskarmene af efter endt polering. Du skal blot sørge for, at vindueskarmene er ryddet for planter og pyntegenstande, inden vi ankommer. Dette sikrer en hurtig og effektiv proces."
        ]
      }
    ]
  },
  ringsted: {
    slug: "vinduespudser-ringsted",
    cityName: "Ringsted",
    title: "Vinduespudser Ringsted | Professionel Vinduespolering",
    metaDescription: "Professionel vinduespudser i Ringsted til private og erhverv. Få skinnende rene vinduer, faste lave priser og pålidelig service fra NF-Polering.",
    h1: "Vinduespudser i Ringsted",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-ringsted-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/byskilt-ringsted.png",
    textSections: [
      {
        h2: "Professionel Vinduespudser i Ringsted",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/byskilt-ringsted.png",
        imageAlt: "Professionel vinduespudser ved Ringsted byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en erfaren og pålidelig vinduespudser i Ringsted? Hos NF-Polering hjælper vi både private boligejere, virksomheder, butikker og boligforeninger med professionel vinduespolering i hele Ringsted og omegn. Vi ved, hvor stor forskel rene vinduer gør for både boligens udseende og mængden af naturligt lys i hjemmet eller på arbejdspladsen.",
          "Vi lægger stor vægt på kvalitet, punktlighed og god service. Uanset om du ønsker en fast aftale eller blot en enkelt vinduespudsning, sørger vi for et flot resultat hver gang. Med moderne udstyr og fokus på detaljerne efterlader vi dine vinduer rene og fri for striber, så du kan nyde udsigten uden generende snavs og kalk."
        ]
      },
      {
        h2: "Vinduespolering i Ringsted for Private og Erhverv",
        paragraphs: [
          "NF-Polering tilbyder vinduespolering i Ringsted til både private husstande og erhvervskunder. Vi servicerer alt fra villaer og rækkehuse til kontorer, butikker, klinikker og erhvervsejendomme. Vores løsninger tilpasses den enkelte kunde, så du får den service, der passer bedst til dine behov.",
          "Mange vælger en fast pudseordning, hvor vi kommer med faste intervaller og sørger for, at vinduerne altid fremstår præsentable. Det sparer tid i hverdagen og sikrer et flot resultat året rundt. Vi arbejder effektivt og professionelt, så du får mest muligt ud af din investering i rene vinduer."
        ]
      },
      {
        h2: "Lokalkendt Vinduespudser i Ringsted",
        paragraphs: [
          "Som lokal vinduespudser i Ringsted kender vi området og servicerer kunder i hele byen samt de omkringliggende områder. Vi er stolte af at levere en personlig service, hvor kunden altid er i centrum. Vores mål er at skabe langvarige kunderelationer gennem høj kvalitet, ærlig rådgivning og konkurrencedygtige priser.",
          "Når du vælger NF-Polering som din vinduespudser i Ringsted, får du en samarbejdspartner, der går op i detaljerne og ikke afslutter arbejdet, før resultatet lever op til vores høje standarder. Kontakt os i dag for et uforpligtende tilbud på professionel vinduespolering i Ringsted."
        ]
      }
    ]
  },
  hoeng: {
    slug: "vinduespudser-hoeng",
    cityName: "Høng",
    title: "Vinduespudser Høng | Professionel Vinduespolering",
    metaDescription: "Leder du efter en vinduespudser i Høng? NF-Polering tilbyder professionel vinduespolering til private og erhverv med flotte resultater og faste aftaler.",
    h1: "Vinduespudser i Høng",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-hoeng-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/ha-ng.png",
    textSections: [
      {
        h2: "Vinduespudser i Høng – Professionel vinduespolering til private og erhverv",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/ha-ng.png",
        imageAlt: "Professionel vinduespudser ved Høng byskilt – NF Polering",
        paragraphs: [
          "Leder du efter en pålidelig vinduespudser i Høng? Hos NF-Polering tilbyder vi professionel vinduespolering til både private boliger, virksomheder, butikker og boligforeninger. Vi ved, hvor stor forskel rene vinduer gør for både boligens udseende og mængden af naturligt lys indenfor.",
          "Vi arbejder med fokus på kvalitet, service og stabile aftaler, så du altid kan være sikker på skinnende rene ruder. Uanset om du ønsker en fast pudseordning eller en enkelt pudsning, tilpasser vi løsningen efter dine behov. Vi servicerer hele Høng og de omkringliggende områder og sørger for, at dine vinduer fremstår flotte året rundt."
        ]
      },
      {
        h2: "Fast vinduespolering i Høng med fleksible intervaller",
        paragraphs: [
          "Mange af vores kunder i Høng vælger en fast aftale, så vinduerne altid fremstår rene uden selv at skulle tænke på det. Med regelmæssig vinduespolering undgår du, at snavs, pollen og belægninger sætter sig fast på glasset, samtidig med at boligen fremstår velholdt.",
          "Hos NF-Polering tilbyder vi fleksible intervaller på 4, 8 eller 12 uger, så du kan vælge den løsning, der passer bedst til dit hjem eller din virksomhed. Vi kommer som aftalt og udfører arbejdet grundigt hver gang. Vores mål er at levere høj kvalitet og god service, så du får en tryg og professionel oplevelse fra start til slut."
        ]
      },
      {
        h2: "Lokalkendt vinduespudser i Høng",
        paragraphs: [
          "Som lokal vinduespudser nær Høng kender vi området og hjælper hver dag kunder med at holde deres vinduer rene og præsentable. Vi udfører vinduespolering på alt fra villaer og rækkehuse til kontorer, butikker og erhvervsejendomme.",
          "Vi lægger stor vægt på grundighed, punktlighed og god kundeservice. Når du vælger NF-Polering, får du en samarbejdspartner, der sætter kvaliteten i højsædet og leverer flotte resultater hver gang. Kontakt os i dag for et uforpligtende tilbud på vinduespolering i Høng, og oplev forskellen ved professionelt pudsede vinduer."
        ]
      }
    ]
  },
  fuglebjerg: {
    slug: "vindusepudser-fuglebjerg",
    cityName: "Fuglebjerg",
    title: "Vinduespudser i Fuglebjerg | NF-Polering",
    metaDescription: "Lokal vinduespudser i Fuglebjerg. Vi tilbyder professionel vinduespolering, faste abonnementsaftaler og høj kvalitet til private og erhverv.",
    h1: "Vinduespudser i Fuglebjerg",
    heroSubtitle: "Få hurtig tid, skarpe priser og et resultat der holder. Ring nu eller udfyld formularen – så får du din pris med det samme.",
    heroImage: "https://assets.auxodev.dk/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/hero-fuglebjerg-vinduespudsning.png",
    byskiltImage: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/vestsja-lland.png",
    textSections: [
      {
        h2: "Professionel vinduespudser i Fuglebjerg",
        image: "https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/e7be4d2d-7d84-4f18-944c-35dc3bc1037c/vestsja-lland.png",
        imageAlt: "Professionel vinduespudser i Fuglebjerg og Vestsjælland – NF Polering",
        paragraphs: [
          "Leder du efter en pålidelig og professionel vinduespudser i Fuglebjerg? Hos NF-Polering tilbyder vi kvalitetsbevidst vinduespolering til både private boliger og virksomheder i Fuglebjerg og de omkringliggende områder. Vi hjælper vores kunder med at holde deres vinduer rene året rundt, så boligen eller virksomheden altid fremstår flot, velholdt og indbydende.",
          "Rene vinduer giver ikke kun et pænere udseende, men også mere dagslys og et bedre udsyn. I et område som Fuglebjerg, hvor mange boliger er omgivet af natur, marker og grønne områder, kan pollen, støv og snavs hurtigt sætte sig på ruderne. Regelmæssig vinduespolering er derfor en effektiv måde at bevare et flot resultat året rundt.",
          "NF-Polering udfører vinduespolering i hele Fuglebjerg og de omkringliggende byer som Dalmose, Sandved, Tornemark, Næstved og de mindre lokalsamfund i området. Uanset om du bor i villa, rækkehus, lejlighed eller sommerhus, kan vi tilbyde en løsning, der passer til dine behov."
        ]
      },
      {
        h2: "Vinduespolering til private og erhverv i Fuglebjerg",
        paragraphs: [
          "Hos NF-Polering hjælper vi både private boligejere og virksomheder med professionel vinduespolering i Fuglebjerg. Vi ved, at rene vinduer gør en stor forskel, både når det gælder boligens udseende og virksomhedens førstehåndsindtryk.",
          "For private kunder betyder professionel vinduespolering, at man slipper for tidskrævende arbejde og samtidig får et flottere resultat. Mange vælger en fast aftale, så vinduerne altid fremstår rene og velholdte uden besvær. For virksomheder er rene vinduer med til at skabe et professionelt og indbydende miljø for både kunder og medarbejdere.",
          "Vi benytter moderne udstyr og professionelle arbejdsmetoder, som sikrer et ensartet og flot resultat. Vores erfaring gør det muligt at håndtere både små og store opgaver, og vi tilpasser altid vores løsning efter kundens ønsker. Uanset om der er tale om en privat bolig, en butik, et kontor eller en større erhvervsejendom, leverer vi vinduespolering med fokus på kvalitet og grundighed."
        ]
      },
      {
        h2: "Lokal service og høj kvalitet i Fuglebjerg",
        paragraphs: [
          "Som lokal vinduespudser nær Fuglebjerg lægger vi stor vægt på god service, høj kvalitet og tilfredse kunder. Vi ved, at tillid og pålidelighed er afgørende, når man vælger en fast samarbejdspartner til vinduespolering, og derfor gør vi os umage ved hver eneste opgave.",
          "Fuglebjerg og omegn byder på mange forskellige boligtyper og virksomheder, og vi har erfaring med alt fra mindre parcelhuse til større erhvervsbygninger. Uanset opgavens størrelse arbejder vi med samme fokus på detaljerne og det færdige resultat. Vores mål er at sikre, at kunderne altid får rene vinduer og en professionel oplevelse.",
          "Hos NF-Polering arbejder vi hver dag for at være det foretrukne valg, når der søges efter en vinduespudser i Fuglebjerg. Gennem professionelt håndværk, personlig service og fokus på kvalitet hjælper vi både private og erhverv med at holde deres vinduer flotte og velholdte året rundt."
        ]
      }
    ]
  }
};

export const SOLCELLEVASK_INFO = {
  pricePerPanel: 22,
  priceUnit: "kr. pr. panel",
  subscriptions: [
    {
      id: "halvaar",
      name: "Halvårsabonnement",
      frequency: "2 gange årligt",
      timing: "Forår & efterår",
      recommended: true,
      badge: "Mest populære",
      priceText: "Kun 22 kr. pr. panel",
      description: "Optimal løsning der sikrer maksimal energiproduktion hele året. Forårsvask fjerner vinterens snavs, og efterårsvask fjerner sommerens pollen og støv forud for vintermånederne.",
      features: [
        "2 årlige vaske med ultra-rent osmosevand",
        "Fast lav pris på 22 kr. pr. panel",
        "Op til 15–25% forbedret energieffektivitet",
        "Automatisk påmindelse og planlægning",
        "Ingen binding – opsig når du vil",
        "Skånsomme specialbørster uden ridser"
      ]
    },
    {
      id: "aar",
      name: "Årsabonnement",
      frequency: "1 gang årligt",
      timing: "Forårsklargøring",
      recommended: false,
      badge: "Årlig klargøring",
      priceText: "Kun 22 kr. pr. panel",
      description: "Den ideelle løsning til dig, der ønsker en årlig grundig rengøring inden højsæsonen i sommermånederne, hvor solskinstimerne er flest.",
      features: [
        "1 årlig grundig forårsvask",
        "Fast lav pris på 22 kr. pr. panel",
        "Fjerner mos, alger, sod, pollen og fugleklatter",
        "100% kalkfrit og kemikaliefrit resultat",
        "Ingen binding – fornyes automatisk",
        "Skånsom vask fra jorden med teleskopstang"
      ]
    },
    {
      id: "enkelt",
      name: "Enkeltstående vask",
      frequency: "Efter behov",
      timing: "Fleksibel bestilling",
      recommended: false,
      badge: "Engangsvask",
      priceText: "22 kr. pr. panel",
      description: "Har du brug for en enkelt vask uden abonnement? Vi rykker hurtigt ud og vasker dine solcellepaneler til samme faste lave pris.",
      features: [
        "Enkeltstående grundig vask",
        "Samme faste pris: 22 kr. pr. panel",
        "100% rent afmineraliseret vand",
        "Hurtig og fleksibel udrykning",
        "Mulighed for senere opgradering til abonnement"
      ]
    }
  ],
  benefits: [
    {
      icon: "fa-bolt",
      title: "Op til 25% mere strøm",
      desc: "Snavs, sod og fugleklatter danner en hinde over solcellerne, som nedsætter el-produktionen markant."
    },
    {
      icon: "fa-droplet",
      title: "100% kemifrit osmosevand",
      desc: "Vi bruger opvarmet, afmineraliseret vand, der tørrer 100% stribe- og kalkfrit uden brug af skadelig kemi."
    },
    {
      icon: "fa-shield-halved",
      title: "Skånsomt mod overfladen",
      desc: "Vores specialudviklede bløde børster og teleskopstænger beskytter cellernes sarte antirefleks-belægning."
    },
    {
      icon: "fa-calendar-check",
      title: "Faste abonnementer uden binding",
      desc: "Vælg halvårs- eller årsabonnement og slip for at tænke på det. Vi passer dine paneler automatisk."
    }
  ],
  faqs: [
    {
      question: "Hvorfor er det nødvendigt at vaske solceller?",
      answer: "Regnvand skyller kun en lille del af snavset væk. Trafikfilm, sod, pollen, alger og fugleklatter brænder sig fast på glasset. Forskning viser, at beskidte solceller kan miste mellem 10% og op til 25% af deres samlede elproduktion. En professionel vask tjener hurtigt sig selv hjem i øget strømproduktion."
    },
    {
      question: "Hvad koster solcellevask hos NF-Polering?",
      answer: "Hos os er prisen helt gennemskuelig: Kun 22 kr. pr. panel. Har du f.eks. et almindeligt parcelhusanlæg med 20 paneler, koster en fuld vask kun 440 kr. inkl. moms."
    },
    {
      question: "Hvorfor må man ikke vaske med haveslange og postevand?",
      answer: "Almindeligt postevand indeholder store mængder kalk og mineraler. Når vandet fordamper i solen, efterlader det et hvidt kalklag på glasset, som er meget svært at fjerne og som blokerer for sollyset. Vi anvender specialfiltreret, afmineraliseret rent vand (osmosevand), som fordamper uden at efterlade en eneste stribe eller plet."
    },
    {
      question: "Hvordan fungerer halvårs- og årsabonnement?",
      answer: "Med et halvårsabonnement vasker vi dine solceller 2 gange årligt (typisk om foråret og om efteråret). Med et årsabonnement kommer vi én gang om året til foråret. Vi kontakter dig altid inden vi kommer, og du har ingen binding – du kan til enhver tid opsige eller ændre aftalen."
    },
    {
      question: "Går I op på taget for at vaske panelerne?",
      answer: "Nej, som udgangspunkt vasker vi panelerne sikkert og skånsomt nede fra jorden ved hjælp af letvægts carbon-teleskopstænger med indbygget vandtilførsel og ultrabløde børster. Det minimerer risikoen for tagskader og sikrer et perfekt resultat."
    }
  ]
};

